document.addEventListener("DOMContentLoaded", function () {

  // Bail out if BOTH objects are empty — no badge data at all on this product
  if (
    typeof window.mostPopularVariants !== 'undefined' &&
    typeof window.valueLabelVariants !== 'undefined' &&
    Object.keys(window.mostPopularVariants).length === 0 &&
    Object.keys(window.valueLabelVariants).length === 0
  ) {
    return;
  }

  const OPTION_NAMES = ['Size', 'Flavor'];
  const SELECTOR = OPTION_NAMES.map(n => `input[type='radio'][name='${n}']`).join(', ');

  function isValidVariantData() {
    // Globals must exist; at least one must have entries
    const mpReady = typeof window.mostPopularVariants !== 'undefined';
    const vlReady = typeof window.valueLabelVariants !== 'undefined';
    if (!mpReady || !vlReady) return false;

    const mpHasData = Object.keys(window.mostPopularVariants).length > 0;
    const vlHasData = Object.keys(window.valueLabelVariants).length > 0;

    // Ready as long as at least one has data — don't require both
    return mpHasData || vlHasData;
  }

  function updateMostPopularBadges() {
    const optionNodes = document.querySelectorAll(".m-product-option--node");
    if (!optionNodes.length) return;

    optionNodes.forEach(optionNode => {
      const optionInput = optionNode.querySelector(SELECTOR);
      if (!optionInput) return;

      const variantKey = optionInput.value.trim();
      const label = optionNode.querySelector(".m-product-option--node__label");
      if (!label) return;

      const mostPopularValue = window.mostPopularVariants?.[variantKey];
      const valueLabel = window.valueLabelVariants?.[variantKey];

      // Badge 1: Most Popular
      if (mostPopularValue) {
        let badge = optionNode.querySelector(".most-popular-badge");
        if (!badge) {
          badge = document.createElement("span");
          badge.classList.add("most-popular-badge");
          label.appendChild(badge);
        }
        badge.textContent = mostPopularValue;
        label.classList.add("highlight-popular");
      }

      // Badge 2: Value Label
      if (valueLabel) {
        let valueBadge = optionNode.querySelector(".value-label-badge");
        if (!valueBadge) {
          valueBadge = document.createElement("span");
          valueBadge.classList.add("value-label-badge");
          label.appendChild(valueBadge);
        }
        valueBadge.textContent = valueLabel;
      }
    });
  }

  function waitForVariantData(callback, retries = 10, delay = 500) {
    if (isValidVariantData()) return callback();

    let attempts = 0;
    const interval = setInterval(() => {
      if (isValidVariantData()) {
        clearInterval(interval);
        callback();
      } else if (++attempts >= retries) {
        clearInterval(interval);
        // Only warn if a product actually has badge metafields set
        const mpHasData = Object.keys(window.mostPopularVariants || {}).length > 0;
        const vlHasData = Object.keys(window.valueLabelVariants || {}).length > 0;
        if (mpHasData || vlHasData) {
          console.warn("⚠️ mostpopular.js: Timed out waiting for variant metafields.");
        }
      }
    }, delay);
  }

  let debounceTimer = null;
  let isUpdating = false;

  const observer = new MutationObserver(() => {
    if (isUpdating) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      isUpdating = true;
      updateMostPopularBadges();
      isUpdating = false;
    }, 100);
  });

  waitForVariantData(() => {
    updateMostPopularBadges();
    const variantContainer = document.querySelector(".m-product-options");
    observer.observe(variantContainer || document.body, { childList: true, subtree: true });
  });

});